import { create } from 'zustand';

import { Subscription, SubscriptionTypes } from 'src/dashboard/settings/billing';
import { Nullable } from 'src/types/nullable.type';

interface State {
  currentSubscription: any;
  subscriptionPlanType: Nullable<SubscriptionTypes>;
  customMsg: string | undefined | null; 
  customHeader: string | undefined | null; 
  subscriptionLoading: boolean;
  isStarter: boolean;
  isPro: boolean;
  isEnterprise: boolean;
  isSubscribed: boolean;
  isOnTrial: boolean;
  openPricingPaywall: boolean;
  setCurrentSubscription: (Subscription: Subscription) => void;
  setOpenPricingPaywall: (pricingToggle: boolean) => void;
  setCustomMsg: (msg: string | null) => void;
  setCustomHeader: (msg: string | null) => void;
}

export const useCurrentSubscription = create<State>((set: any, get: any) => ({
  currentSubscription: null,
  subscriptionLoading: true,
  subscriptionPlanType: null,
  customHeader: null,
  customMsg: null,
  isStarter: false,
  isPro: false,
  isEnterprise: false,
  isSubscribed: false,
  isOnTrial: false,
  openPricingPaywall: false,
  setOpenPricingPaywall: (pricingToggle: boolean) => {
    set({openPricingPaywall: pricingToggle})
  },
  setCustomMsg: (msg: string | null) => {
    set({customMsg: msg})
  },
  setCustomHeader: (msg: string | null) => {
    set({customHeader: msg})
  },
  setCurrentSubscription: (subscription: Subscription) => {
    set({ 
        currentSubscription: subscription,
        subscriptionPlanType: subscription?.plan_type ?? null,
        isStarter: subscription?.plan_type==='starter',
        isPro: subscription?.plan_type==='pro',
        isEnterprise: subscription?.plan_type==='enterprise',
        isSubscribed: subscription?.status === 'active', 
        isOnTrial: subscription?.status === 'trialing',
        subscriptionLoading: false
    });
  }
}));
